export enum MigrationStatus {
    New = 'New',
    Evaluation = 'Evaluation',
    EvaluationNotInUse = 'EvaluationNotInUse',
    Approved = 'Approved',
    Planed = 'Planed',
    Transfer = 'Transfer',
    Closed = 'Closed',
}
